export const VIC = {
  display: 'VIC',
  url: 'vic',
};

export const NSW = {
  display: 'NSW',
  url: 'nsw',
};

export const QLD = {
  display: 'QLD',
  url: 'qld',
};

export const WA = {
  display: 'WA',
  url: 'wa',
};

export const SA = {
  display: 'SA',
  url: 'sa',
};

export const TAS = {
  display: 'TAS',
  url: 'tas',
};

export const ACT = {
  display: 'ACT',
  url: 'act',
};

export const NT = {
  display: 'NT',
  url: 'nt',
};
